import { Injectable } from '@angular/core';
import { Usuario } from '../../api.service';

export type AbaAdministrativa = 'registrador' | 'empregador' | 'departamentos' | 'funcionario' | 'relogio' | 'exportacao' | 'pendencias' | 'ajustes' | 'ferias' | 'usuarios' | 'auditoria';

export interface CarregamentosAbaAdministrativa {
  empregadorCadastro: boolean;
  relogio: boolean;
  jornadas: boolean;
  terminais: boolean;
  funcionariosExportacao: boolean;
  departamentos: boolean;
}

@Injectable({ providedIn: 'root' })
export class ServicoNavegacaoAdministrativa {
  abaPorUrl(url: string): AbaAdministrativa {
    const rota = this.normalizarRota(url);
    const abaPorRota: Record<string, AbaAdministrativa> = {
      registrar: 'registrador',
      registrador: 'registrador',
      empregador: 'empregador',
      departamentos: 'departamentos',
      funcionario: 'funcionario',
      relogio: 'relogio',
      exportacao: 'exportacao',
      pendencias: 'pendencias',
      ajustes: 'ajustes',
      ferias: 'ferias',
      usuarios: 'usuarios',
      auditoria: 'auditoria'
    };
    return abaPorRota[rota] || 'registrador';
  }

  rotaDaAba(aba: AbaAdministrativa) {
    return aba === 'registrador' ? 'registrador' : aba;
  }

  exigeAdministradorGlobal(aba: AbaAdministrativa) {
    return aba === 'empregador' || aba === 'usuarios';
  }

  ehAdministradorGlobal(usuario?: Usuario) {
    return usuario?.perfil === 'ADMIN_GLOBAL';
  }

  podeAcessarAba(aba: AbaAdministrativa, usuario?: Usuario, terminalPublico = false) {
    if (terminalPublico || !usuario) {
      return true;
    }

    return !this.exigeAdministradorGlobal(aba) || this.ehAdministradorGlobal(usuario);
  }

  carregamentosDaAba(aba: AbaAdministrativa): CarregamentosAbaAdministrativa {
    return {
      empregadorCadastro: aba === 'empregador',
      relogio: aba === 'relogio',
      jornadas: aba === 'relogio' || aba === 'pendencias',
      terminais: aba === 'relogio',
      funcionariosExportacao: aba === 'exportacao' || aba === 'pendencias' || aba === 'auditoria',
      departamentos: aba === 'departamentos' || aba === 'funcionario' || aba === 'exportacao' || aba === 'usuarios' || aba === 'relogio'
    };
  }

  ehRotaLogin(url: string) {
    return this.normalizarRota(url) === 'login';
  }

  private normalizarRota(url: string) {
    return (url || '')
      .split('?')[0]
      .split('#')[0]
      .replace(/^\/+/, '')
      .split('/')[0]
      .toLowerCase();
  }
}
